export * from './form-dialog-standard-submit-buttons';
export * from './name-validation-errors';
export * from './basic-validation-errors';

import { BasicValidationErrorsComponent } from './basic-validation-errors';
import { FormDialogStandardSubmitButtonsComponent } from './form-dialog-standard-submit-buttons';
import { NameValidationErrorsComponent } from './name-validation-errors';

export const FormMolecules = [
    FormDialogStandardSubmitButtonsComponent,
    NameValidationErrorsComponent,
    BasicValidationErrorsComponent
]